module.exports = __webpack_public_path__ + "static/media/1-3.15acbee8.mp3";